type Props = {
  url: string;
  title: string;
  onClose: () => void;
};

export const PdfPreview = ({ url, title, onClose }: Props) => (
  <div className="pdf-drawer">
    <header>
      <h2>{title}</h2>
      <button onClick={onClose}>×</button>
    </header>
    <iframe title={title} src={url} />
  </div>
);
